import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, Typography } from '@mui/material';
import React from 'react';
import { ISIVReportConfirmPage } from 'src/types/SIVReport';
import ConfirmPage from './Signatures';
import './SivReport.scss';
import {
  ISIVReportMandatory,
  ISIVReportModifiedKeys,
  ISIVReportModifiedKeysOfKeys,
  ISIVReportStep3Accordions,
  MandatoryData
} from './useSivReport';

export interface ISIVReportPageStep3 {
  getSivReportData: (key: ISIVReportModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  expandedState: ISIVReportStep3Accordions;
  toggle: (key: keyof ISIVReportStep3Accordions, expanded: boolean) => void;
  isUpdate: boolean;
  confirmPageData: ISIVReportConfirmPage;
  updateConfirmPage: (data: ISIVReportConfirmPage) => void;
  setIsChange: (step: ISIVReportModifiedKeys, key: ISIVReportModifiedKeysOfKeys, val: boolean) => void;
  Step3: ISIVReportStep3Accordions;
  updateSIVReportMandatoryData: (key: keyof ISIVReportMandatory, value: MandatoryData) => void;
  mandatory: ISIVReportMandatory;
  sivReportSavedId: string;
  checkedInStartDate: any;
  validateAllAccordionForSign: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
  notifyUser: any;
}

const SIVReportPage: React.FunctionComponent<ISIVReportPageStep3> = ({
  getSivReportData,
  saveDisable,
  confirmPageData,
  expandedState,
  isUpdate,
  toggle,
  updateConfirmPage,
  Step3,
  setIsChange,
  updateSIVReportMandatoryData,
  mandatory,
  sivReportSavedId,
  checkedInStartDate,
  validateAllAccordionForSign,
  isPublished,
  SignatureBreaking,
  notifyUser
}) => {
  return (
    <div className="pi-accordion siv-accordion">
      <Accordion
        expanded={expandedState.confirmPage}
        onChange={(_, expanded) => {
          toggle('confirmPage', expanded);
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
          <Typography>Confirm </Typography>
        </AccordionSummary>
        <ConfirmPage
          getSivReportData={getSivReportData}
          saveDisable={saveDisable}
          isChange={Step3.confirmPage}
          confirmPageData={confirmPageData}
          isUpdate={isUpdate}
          setIsChange={setIsChange}
          updateConfirmPage={updateConfirmPage}
          updateSIVReportMandatoryData={updateSIVReportMandatoryData}
          mandatory={mandatory.confirmPage}
          sivReportSavedId={sivReportSavedId}
          checkedInStartDate={checkedInStartDate}
          validateAllAccordionForSign={validateAllAccordionForSign}
          isPublished={isPublished}
          SignatureBreaking={SignatureBreaking}
          notifyUser={notifyUser}
        />
      </Accordion>
    </div>
  );
};

export default SIVReportPage;
